import React, { Component } from "react";
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing"

import "./Header.scss"

class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false,
      isSlided: false
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  componentWillMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isSlided: (window.scrollY > 0.10 * window.screen.width ? true : false)
      })
    });
  }
  activateSharer() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  render() {
    return (
      <header>
      <div id="bananas">
        <div className="bananabanner">
          <iframe title="Banana" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" allowtransparency="true" src="https://z.ynet.co.il/short/commerce/2015/links/header/Default.aspx"></iframe>
        </div>
      </div>
        <div id="header" className={`${(this.state.isSlided ? "active" : "")}`}>
          <div className="padding">
            <div className="container">
              <div className="utils">
                <div className={`share`}>
                  <div onClick={() => { openNegishut() }} className="negishut"></div>
                  <div onClick={() => { shareFacebook() }} className="facebook"></div>
                  <div onClick={() => { shareWhatsapp() }} className="whatsapp"></div>
                </div>
                <div className="logo"></div>
              </div>
            </div>
          </div>
        </div> 
        <div id="virtualHeader" className={`${(window.location.href.indexOf("whoami") > -1 ? "lead" : "")}`}></div>
        
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx